import { useMemo } from 'react'

import { Nullable } from 'cng-common/models/utils'
import { ModalDialog } from 'core-components/library/modalDialog'

import { ContactRelinkingValidationMessageContent } from './ContactRelinkingValidationMessageContent'

import styles from './ContactRelinkingValidationMessage.module.scss'

interface Props {
  text: Nullable<string>
  onClose: () => void
}

export const ContactRelinkingValidationMessage = ({ text, onClose }: Props) => {
  const contentProps = useMemo(() => {
    return {
      text,
      onCancel: onClose,
    }
  }, [onClose, text])

  return (
    <div className={styles.root}>
      <ModalDialog
        classes={styles}
        show={Boolean(text)}
        content={ContactRelinkingValidationMessageContent}
        contentProps={contentProps}
        onClose={onClose}
        size="sm"
      />
    </div>
  )
}
